import React, { useState, useEffect } from "react";
import "./Form9.scss";
import { FiArrowRight, FiX, FiPlus } from "react-icons/fi";
import { connect } from "react-redux";

import { signup } from "../../../store/auth/actions";

const Form9 = (props) => {
  const [link, setLink] = useState("");

  const disabledBtn = () => {
    if (!link)
      return true;
    return false;
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setLink(value);
  };

  const handleSubmit = async () => {
    console.log(props.userData)
    await props.signup({
      userId: props.userData.signupData.userId,
      my_audition_track: link,
    });
    props.clicking();
  };

  return (
    <div className="Form9 w-100">
      <div className="h1">My audition track ...</div>
      <div className="note text-muted text-left">Connect with SoundCloud</div>
      <div className="row">
        <div className="col-12">
          <div className="image-upload">
            <input
              type="text"
              className="input form-control"
              placeholder="Insert soundcloud link"
              value={link}
              onChange={handleChange}
              required
            />
            {/* <input type="file" name="" id="img-1" /> */}
            {/* <label
              htmlFor="img-1"
              // style={{
              //   backgroundImage:
              //     "url(https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500)",
              // }}
            >
              <FiPlus />
              <div className="close d-none">
                <FiX />
              </div>
            </label> */}
          </div>
        </div>
      </div>

      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary btn-block rounded-3 btn-lg mt-4"
          onClick={() => handleSubmit()}
        >
          Sign Up
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth,
});

export default connect(mapStateToProps, {
  signup,
})(Form9);
